// extracted by mini-css-extract-plugin
export default {"iframe":"MobileVideoPlayer_iframe__3zsnr"};